export const SCROLL_BUFFER = 50;

export const isElementInViewport = (rect: ClientRect, parentRect: ClientRect) =>
	rect.top - parentRect.top - SCROLL_BUFFER >= 0 &&
	parentRect.bottom - rect.bottom - SCROLL_BUFFER >= 0 &&
	rect.left - parentRect.left >= 0 &&
	parentRect.right - rect.right - SCROLL_BUFFER >= 0;

export const isPrevElementInViewport = (
	rect: ClientRect,
	sourceRect: ClientRect,
	parentRect: ClientRect,
) =>
	rect.top + sourceRect.height - parentRect.top - SCROLL_BUFFER >= 0 &&
	parentRect.bottom + sourceRect.height - rect.bottom - SCROLL_BUFFER >= 0 &&
	rect.left - parentRect.left >= 0 &&
	parentRect.right - rect.right - SCROLL_BUFFER >= 0;

export const isColumnInViewport = (rect: ClientRect, parentRect: ClientRect) =>
	rect.top - parentRect.top >= 0 &&
	rect.left - parentRect.left >= 0 &&
	parentRect.right - rect.right - SCROLL_BUFFER >= 0;
